// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FileUploadPresentationPropsDefault from "@insite/mobius/FileUpload/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import Minus from "@rugby/XDL/Icons/Minus";
import { xBaseTheme } from "@rugby/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...FileUploadPresentationPropsDefault,
        cssOverrides: {
            appearanceTransition: css`
                button[class*="FormFieldClickable"] {
                    right: 0 !important;
                }
                input {
                    box-sizing: border-box;
                    border: 2px solid ${getColor("common.border")};
                }
            `,
        },
        iconProps: {
            src: "",
        },
        clearIconProps: {
            src: Minus,
            color: "text.main",
        },
    },
} as xBaseTheme["fileUpload"];
